import { useLocale } from '@mirai/locale';
import { Action, Notification } from '@mirai/ui';
import PropTypes from 'prop-types';
import React from 'react';

import { L10N } from './NotificationRequiredFields.l10n';
import * as style from './NotificationRequiredFields.module.css';

const OFFSET = 16;

const NotificationRequiredFields = ({ form = 'form', values = {}, ...others }) => {
  const { translate } = useLocale();

  const handlePress = (id) => {
    const el = document.querySelector(id);
    el && window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - OFFSET, behavior: 'smooth' });
  };

  const totalErrors = Object.keys(values).length;
  const [firstError] = Object.keys(values);

  return totalErrors ? (
    <Notification {...others} row error wide>
      {translate(L10N.NOTIFICATION_FIX_FORM_ERRORS, {
        amount: totalErrors,
        link: (
          <Action
            underline
            onPress={() => handlePress(`#${form}-${firstError.replace(/\./g, '-')}`)}
            className={style.field}
          >
            {translate(L10N.ACTION_FIX_FIRST_ERROR)}
          </Action>
        ),
      })}
    </Notification>
  ) : null;
};

NotificationRequiredFields.displayName = 'Mirai:Core:NotificationRequiredFields';

NotificationRequiredFields.propTypes = {
  form: PropTypes.string,
  values: PropTypes.shape({}),
};

export { NotificationRequiredFields };
